import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* getList(actions) {
    console.log('%c sagaBillings / getList / actions.query :', 'color: #b37900; background: #fff7e6', actions.query);
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/billing_form/?offset=0&limit=${actions.limit}`
            : `${config.credentials.url}/billing_form/${actions.query}`

        console.log('%c getList / url :', 'color: #3786B3; background: #C7DFFF', url);

        const response = yield call(apiCall, 'get', url, requestOptions)

        console.log('%c sagaBillings / getList / response :', 'color: #b37900; background: #fff7e6', response);

        yield put({ type: "GET_RESPONSE_BILLINGS_LIST", value: response })
    } catch (error) {
        yield put({ type: "GET_RESPONSE_BILLINGS_LIST", value: error })
    }
}

function* billingById(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        const response = yield call(apiCall, 'get', config.credentials.url + '/billing_form/' + actions.id + '/', requestOptions)
        yield put({ type: "GET_BILLING_BY_ID", value: response })
    } catch (error) {
        yield put({ type: "GET_BILLING_BY_ID", value: error })
    }
}

function* editBilling(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/billing_form/' + actions.id + '/', requestOptions)
        yield put({ type: "BILLING_EDIT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "BILLING_EDIT_RESPONSE", value: error })
    }
}

function* hashExportBilling(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null || actions.query === ''
                ? config.credentials.url + '/billing_form_report/?offset=0&limit=500'
                : config.credentials.url +
                '/billing_form_report/' +
                actions.query +
                '&offset=0&limit=500';
        const response = yield call(apiCall, 'get', url, requestOptions);

        yield put({ type: 'HASH_EXPORT_BILLING_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'HASH_EXPORT_BILLING_RESPONSE', value: error });
    }
}


function* checkExportBilling(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_BILLING_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_BILLING_RESPONSE', value: error });
    }
}


export function* getBillingsList() {
    yield takeEvery("GET_BILLINGS_LIST", getList)
}

export function* getBillingById() {
    yield takeEvery("GET_BILLING", billingById)
}

export function* editBillingById() {
    yield takeEvery("EDIT_BILLING", editBilling)
}

export function* getHashExportBillingList() {
    yield takeEvery('GET_HASH_EXPORT_BILLING', hashExportBilling);
}

export function* checkExportBillingList() {
    yield takeEvery('CHECK_EXPORT_BILLING', checkExportBilling);
}